import { useCallback } from 'react';
import { useQuery, useQueryClient } from 'react-query';

export default function useVisibleModalWarrning() {
  const queryClient = useQueryClient();
  const { data: visibleModalAlertWarring }: any = useQuery('visible_modal_warring', () =>
    queryClient.getQueryData('visible_modal_warring')
  );

  const setVisibleModalAlertWarrning = useCallback(
    (value: any) => queryClient.setQueryData('visible_modal_warring', value),
    [queryClient]
  );
  const { data: url }: any = useQuery('url_history', () => queryClient.getQueryData('url_history'));

  const setUrl = useCallback((value: any) => queryClient.setQueryData('url_history', value), [queryClient]);

  return { visibleModalAlertWarring, setVisibleModalAlertWarrning, url, setUrl };
}
